import {BaseContainerModel} from '../../base-container.model';
import {
  bl_fi_consolidated_arap_hdr_RowClass
} from '../../../dbschema/index';

export class ConsolidatedArapHdrContainer extends BaseContainerModel {
  bl_fi_consolidated_arap_hdr: bl_fi_consolidated_arap_hdr_RowClass = new bl_fi_consolidated_arap_hdr_RowClass();

}